import './sweet-alert.css';
import SweetAlert from 'react-bootstrap-sweetalert';

export default SweetAlert;
